// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-DESZ","top":"styles_top__2akvn","left":"styles_left__3y7Hs","description":"styles_description__2cnZm"};